/**
 * The Organization settings sub-nav's tabs: the label a reader sees for each
 * page, and the route it sits on (Kris, Sep 30, 2026, #1419).
 *
 * Its own module rather than an export from OrgSettingsTabs.tsx, for the same
 * reasons settingsTabList.ts gives: the sub-nav and the Ask Forged context
 * pill both read it, and a component file that also exports constants breaks
 * fast refresh. Not orgSettingsTabs.ts, which would differ from the component
 * file only in case (see settingsTabList.ts for what that broke on Windows).
 *
 * Billing stays on `/organization-settings` itself: that path is the Stripe
 * checkout return URL and is baked into delivered emails, so it keeps landing
 * on Billing (see routes/_app/organization-settings.tsx). There is no General
 * tab (Kris, Oct 10, 2026, #3721): the organization's name is the billing
 * details' first field, Delete organization sits at the bottom of Data, and
 * /organization-settings/general opens Billing so old links still land.
 *
 * Billing shows for admins and billing admins only (Kris, Oct 10, 2026);
 * OrgSettingsTabs leaves it out for a member.
 */
import { V3_SCREENS } from "./v3Routes";

export const BILLING_TAB_PATH = "/organization-settings";

export const ORG_SETTINGS_TABS = [
  { to: BILLING_TAB_PATH, label: "Billing" },
  { to: "/organization-settings/members", label: "Members" },
  // The archived projects, which an admin restores (issue #1798).
  { to: "/organization-settings/projects", label: "Projects" },
  // One ZIP of the organization's data, which an admin prepares (issue #1834).
  { to: "/organization-settings/data", label: "Data" },
] as const;

type OrgSettingsTabPath = (typeof ORG_SETTINGS_TABS)[number]["to"];

/**
 * A tab's browser tab title, the tab then the screen ("Members, Organization
 * settings"), as Memory's tabs title theirs (#3685). The tabs draw no heading
 * of their own, so this is what names the tab outside the page.
 */
export function orgSettingsTabTitle(to: OrgSettingsTabPath): string {
  const tab = ORG_SETTINGS_TABS.find((t) => t.to === to)!;
  return `${tab.label}, ${V3_SCREENS.org.section}`;
}
